export default __webpack_public_path__ + "static/media/logo.sungroup.95e0359e.png";